import React from 'react';
import './ImageDescription.css';
import { useTranslation } from 'react-i18next';
const ImageDescription = ({
  title,
  subtitle,
  paragraphs,
  paragraph,
  paraForBulletPoints,
  imageSrc,
  alignment,
  bulletPoints,
  bulletType = 'bullets',
}) => {
  const { t } = useTranslation();

  const containerStyle = {
    textAlign: alignment || 'center'
  };

  return (
    <div className="custom-component-container" style={containerStyle}>

      {title && <h1 className="custom-title">{t(title)}</h1>}

      {imageSrc && (
        <img
          src={imageSrc}
          alt="content"
          className="custom-image"
        />
      )}

      {subtitle && <p className="custom-subtitle">{t(subtitle)}</p>}

      {/* single paragraph */}
      {paragraph && (
        <p className="custom-paragraph">{t(paragraph)}</p>
      )}

      {/* paragraphs: array of strings or single string */}
      {paragraphs && (
        Array.isArray(paragraphs) ? (
          paragraphs.map((p, index) => (
            <p key={index} className="custom-paragraph">
              {t(p)}
            </p>
          ))
        ) : typeof paragraphs === 'string' ? (
          <p className="custom-paragraph">{t(paragraphs)}</p>
        ) : null
      )}

      {/* paragraph group */}
      <div className="custom-paragraph2-container">
        {Array.isArray(paraForBulletPoints) &&
          paraForBulletPoints.map((paragraph2, index) => (
            <p key={index} className="custom-paragraph2">
              {t(paragraph2)}
            </p>
          ))}
      </div>

      {/* bullet points: bulletType = "bullets" | "tickmark" | "numbers" */}
      {Array.isArray(bulletPoints) && bulletPoints.length > 0 && (() => {
        const ListTag = bulletType === 'numbers' ? 'ol' : 'ul';
        const listClass = `custom-bullet-list custom-bullet-list--${bulletType}`;
        return (
          <ListTag className={listClass}>
            {bulletPoints.map((item, index) => (
              <li key={index} className="custom-bullet-item">

                {typeof item === "string" && t(item)}

                {typeof item === "object" && (
                  <>
                    <strong>{t(item.point)}</strong>
                    {item.paragraph && (
                      <p className="custom-bullet-paragraph">
                        {t(item.paragraph)}
                      </p>
                    )}
                  </>
                )}

              </li>
            ))}
          </ListTag>
        );
      })()}

    </div>
  );
};

export default ImageDescription;